import React from "react";

import Bouton from "@/ui/bouton";

import { FiltreItem } from "@/types/filtres";

import styles from "./tag.module.scss";

type FiltreTagListeProps = {
    children: React.ReactNode;
};

const FiltreTagListe = ({ children }: FiltreTagListeProps) => {
    return (
        <div className={styles.blockFiltreTags} data-component="filtre-tag-liste">
            <ul className={styles.tagsListe}>{children}</ul>
        </div>
    );
};

type FitreTagItemProps = {
    filtre: FiltreItem;
    onClick: (item: FiltreItem) => void;
};

const FitreTagItem = ({ filtre, onClick }: FitreTagItemProps) => {
    return (
        <li data-id={filtre.id} className={styles.tag} data-component="filtre-tag-item">
            <Bouton
                borderOnly
                className={styles.btn}
                icon="fermer"
                onClick={() => onClick(filtre)}
                onClickParam={filtre}
            >
                {filtre.nom}
            </Bouton>
        </li>
    );
};

export { FitreTagItem, FiltreTagListe };
